<template>
  <div class="text-center">
    <v-dialog v-model="show" class="modal" persistent width="500">
      <v-card>
        <v-card-title class="headline" style="text-transform: capitalize">
          Restore {{ unit }}
        </v-card-title>

        <v-card-text>
          <p>
            Are you sure you want to restore the {{ unit }}: <b>{{ name }}</b
            >?
          </p>

          <slot name="text" />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="default" plain @click="cancel"> Cancel </v-btn>

          <v-spacer></v-spacer>
          <v-btn color="success" tile dark large @click="restore">
            Yes, Restore
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    unit: { type: String },
    name: { type: String },
    value: Boolean
  },
  data() {
    return {
      model: {}
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    restore() {
      this.$emit('restore')
    }
  }
}
</script>
